import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../services';

/**
 * Generated class for the TakeawayOrderInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-order-info',
  templateUrl: 'takeaway-order-info.html',
})
export class TakeawayOrderInfoPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public takeawayServices: TakeawayServices,
    public globals: Globals,) {
  }

  back() {
    if (this.takeawayServices.quick_create) {
      this.takeawayServices.quick_create = false;
      this.navCtrl.pop();
      this.navCtrl.pop();
    } else {
      this.navCtrl.pop();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-order/takeaway-order-info/takeaway-order-info.ts